module.exports = __webpack_public_path__ + "static/media/Report.d08b4b3a.svg";